// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-1d2790b0] {\n  max-width: 210px;\n  margin: auto auto 30px;\n  flex-wrap: wrap;\n  padding: 15px 10px;\n  width: 100%;\n  box-shadow: -1px 1px 3px 3px rgba(0, 0, 0, 0.1);\n}\n.container .info[data-v-1d2790b0] {\n  font-weight: bold;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
